import React, { useState } from "react";
import { Box } from "@chakra-ui/react";
import { SCROLLBAR_STYLES } from "../../duck";

interface ViewProps {
  text?: string;
}

const CommentText: React.FC<ViewProps> = ({ text = "" }) => {
  const [collapsed, setCollapsed] = useState(true);

  return (
    <Box
      border="3px solid transparent"
      maxH={80}
      overflowY={collapsed ? "hidden" : "auto"}
      sx={{
        ...SCROLLBAR_STYLES,
        ...(collapsed
          ? {
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: "3",
              display: "-webkit-box"
            }
          : {})
      }}
      onClick={(e: React.MouseEvent) => {
        setCollapsed(prev => !prev);
        (e.target as HTMLDivElement).scrollTop = 0;
      }}
      cursor="pointer"
    >
      {text}
    </Box>
  );
};

export default CommentText;
